module.exports = __webpack_public_path__ + "img/ring_y_e_0_0@2x.4285fc8c.png";